import { PermissionResult } from './PermissionResult';
import { runInspectionFn } from '../utils/runInspectionFn';
import {checkPermissionFn} from "../../AccessChecker/checkPermissionFn";
import { checkModifierFn } from './helper';

export class PermissionResultRecurring extends PermissionResult {
    constructor(permissionKeysByType, permissionKeysByRecurring, defaultRequiredLevel) {
        super([], defaultRequiredLevel);
        this.permissionKeysByType = permissionKeysByType || [];
        this.permissionKeysByRecurring = permissionKeysByRecurring || [];
    }

    /**
     * true whenever ANY of the item in modifierArr is present in the key's modifier [OR conditional]
     * true if modifierArr is [] / null / undefined
     * @param {String[]} modifierArr eg: ['M1', 'M3']
     * @returns boolean
     */
    hasSomeModifier(modifierArr) {
        return checkModifierFn(this.permissionKeysByType, modifierArr, 'some');
    }

    // returns: boolean
    hasPermissionTo(oldRequiredLevel, inhibitorModifiers) {
        const requiredLevel = this.getRequiredLevel(oldRequiredLevel);

        let permission;
        if (this.permissionKeysByRecurring.length !== 0)
            permission = runInspectionFn(checkPermissionFn, this.permissionKeysByRecurring, 'AND', requiredLevel);

        else
            permission = runInspectionFn(checkPermissionFn, this.permissionKeysByType, 'AND', requiredLevel);

        const permissionInhibitedByModifiers = this.hasSomeModifier(
            this.getInhibitorModifiers(inhibitorModifiers),
        ); // True == No Permission

        return permission && !permissionInhibitedByModifiers;
    }
}
